// src/pages/sessions/components/LiveSession/layout/SessionTimer.jsx
import React, { useState, useEffect, useRef, memo } from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

const SessionTimer = memo(() => {
  const [duration, setDuration] = useState(0);
  const intervalRef = useRef(null);
  // Store start time in ref so it persists
  const startTimeRef = useRef(Date.now());
  
  useEffect(() => {
    const updateTimer = () => {
      const elapsed = Math.floor((Date.now() - startTimeRef.current) / 1000);
      setDuration(elapsed);
    };
    
    // Initial update
    updateTimer();
    
    // Start interval
    intervalRef.current = setInterval(updateTimer, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []); // Empty deps - only run once on mount

  const formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="flex items-center space-x-1 text-white text-sm">
      <ClockIcon className="w-4 h-4 text-white" />
      <span>{formatDuration(duration)}</span>
    </div>
  );
});

SessionTimer.displayName = 'SessionTimer';

export default SessionTimer;